<div class="subject__main-content scrollable-component scrollable container-fluid" #contentRevised>

  <div *ngIf="uiState === overviewUiState.IS_LOADING">
    <div class="cv-loading-container">
      <div class="cv-loading-container __spinner"></div>
    </div>
  </div>

  <div *ngIf="
    uiState === overviewUiState.IS_READY &&
    schemaNumber &&
		documentOrder && (documentOrder.InspectionReport || documentOrder.CV_EXTENSION_SECTION) &&
    documentSchema && (documentOrder.InspectionReport || documentOrder.CV_EXTENSION_SECTION)
  ">
    <div class="row" *ngFor="let section of sections">
      <div class="col-12">
        <div class="card cv-card__main shadow-sm">
          <div class="card-header">{{section.title}}</div>
          <div class="card-body">
            <div class="row" *ngFor="let row of section.items">

              <div *ngFor="let field of row" class="{{field.cssClass}}">
                <div [ngSwitch]="field.type">

                  <div *ngSwitchCase="'table'">
                    <ng-template *ngTemplateOutlet="tableTpl; context: {$implicit: field}"></ng-template>
                  </div>

                  <div *ngSwitchCase="'static-table'">
                    <ng-template *ngTemplateOutlet="staticTableTpl; context: {$implicit: field}"></ng-template>
                  </div>

                  <div class="cv__review-fields_multi-rows" *ngSwitchCase="'multi-rows'">
                    <div class="row" *ngFor="let row of field.fields">
                      <ng-container *ngFor="let innerField of row">
                        <div [ngClass]="innerField.cssClass || 'col-md-12'" [ngSwitch]="innerField.type">
                          <div *ngSwitchCase="'table'">
                            <ng-template *ngTemplateOutlet="tableTpl; context: {$implicit: innerField}"></ng-template>
                          </div>

                          <div *ngSwitchCase="'static-table'">
                            <ng-template *ngTemplateOutlet="staticTableTpl; context: {$implicit: innerField}"></ng-template>
                          </div>

                          <div *ngSwitchDefault>
                            <ng-template *ngTemplateOutlet="fieldTpl; context: {$implicit: innerField}"></ng-template>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>

                  <div class="cv__review-fields_range" *ngSwitchCase="'range'">
                    <h6 *ngIf="field.options?.label">{{field.options?.label || ''}}</h6>
                    <div *ngFor="let innerField of field.options.fields; let i = index;" class="d-inline-block">
                      <ng-template *ngTemplateOutlet="fieldTpl; context: {$implicit: innerField}"></ng-template>
                      <div class="range-connector">
                        <p>
                          <span class="px-1" *ngIf="i===0">To</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div *ngSwitchCase="'composite-text'">
                    <p>
                      <span *ngFor="let part of field.options.text.split('{*}'); let i = index;">
                        {{part}}
                        <span class="font-weight-bold" *ngIf="i < (field.options.text.split('{*}').length - 1)">
                          <ng-template *ngTemplateOutlet="fieldTpl; context: {$implicit: field.options.fields[i]}"></ng-template>
                        </span>
                      </span>
                    </p>
                  </div>

                  <div *ngSwitchDefault>
                    <ng-template *ngTemplateOutlet="fieldTpl; context: {$implicit: field}"></ng-template>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cv-historical-values></cv-historical-values>
  </div>
</div>

<ng-template #fieldTpl let-field>
  <cv-in-review-fields
      class="cv_col"
      #fields
      [targets]="selectedTargets"
      [highlight]="selectedType"
      [options]="field.options"
      [orderId]="selectedOrderRow"
      [selectedSection]="selectedSection"
      ></cv-in-review-fields>
</ng-template>

<ng-template #tableTpl let-field>
  <cv-in-review-tables
    #tables
    [field]="field"
    [selectedType]="selectedType"
    [selectedTargets]="selectedTargets"
    ></cv-in-review-tables>
</ng-template>

<ng-template #staticTableTpl let-field>
  <cv-in-review-static-tables
    #tables
    [field]="field"
    [selectedType]="selectedType"
    [selectedTargets]="selectedTargets"
    ></cv-in-review-static-tables>
</ng-template>

